// React
import React, { forwardRef, useContext } from "react";
// Libraries
import { NavLink } from "react-router-dom";
import cn from "classnames";
import SVG from "react-inlinesvg";
// Utils
import { AppContext } from "config/appProvider";
import { FEATURES } from "constants/Features";
import { DASHBOARD, TRADING, ANIMALS } from "constants/Routes";
import { BU_TYPES } from "trading/constants";
import { ELEMENTS_IDS } from "constants/ElementsIds";
import { hasFeature } from "helpers/general";
// Resources
import logoSVG from "assets/img/brand/logo.svg";
import styles from "./RootMenuLogo.module.scss";

interface RootMenuLogoProps {
  className?: string;
}

export const RootMenuLogo: React.FC<RootMenuLogoProps> = forwardRef<HTMLAnchorElement, RootMenuLogoProps>(
  ({ className, ...props }, forwardedRef) => {
    const { mainAppState } = useContext(AppContext);
    const isShowHomePage = hasFeature(FEATURES.SHOW_HOME_PAGE, mainAppState.featuresList);
    const isProcessor = mainAppState.selectedBUType === BU_TYPES.processor;
    const pathToRedirect = isProcessor ? TRADING : ANIMALS;

    return (
      <NavLink
        id={ELEMENTS_IDS.ROOT_MENU_LOGO}
        to={isShowHomePage ? DASHBOARD : pathToRedirect}
        className={cn(styles.root_menu_logo, className)}
        ref={forwardedRef}
        {...props}
      >
        <SVG src={logoSVG} />
      </NavLink>
    );
  },
);
RootMenuLogo.displayName = "RootMenuLogo";
